/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react'
import Box from '@mui/material/Box'
import Input from '../../Common/ui/input'
import { useForm } from 'react-hook-form'
import SaveCancelButton from '../../Common/ui/SaveCancelButton'
import { Button } from '../../Common/ui/button'
import { Card, CardContent } from '../../Common/ui/card'
import { RadioGroup, RadioGroupItem } from '../../Common/ui/radio-group'
import SelectInput from '../../Common/ui/selectInput'
import Textarea from '../../Common/ui/textArea'
import { IoAdd } from 'react-icons/io5'
import MultiFileSelect from '../../Common/ui/MultiSelectFile'
import { useTranslation } from 'react-i18next'
import Heatmap from 'react-heatmap-grid'
import { Dialog, DialogActions, DialogContent, DialogTitle, Chip, Tooltip, DialogContentText } from '@mui/material'
import * as RiskTypes from '../../Entities/RiskTypes'
import * as MeetingTypes from '../../Entities/MeetingTypes'
import { useRiskStore } from './Store/RiskStore'
import DatePickerInput from '../../Common/ui/DatePickerInput'
import Loading from '../../Common/ui/Loading'
import useCustomNavigate from '../../Common/ui/Navigate'
import * as RoutePath from '../../Entities/RoutePath'
import { cn, convertFileToBase64, inputValidation } from '../../lib/utils'
import AddOnTable from 'src/Common/ui/AddOnTable'
import '../../Styles/AddRisk.css'
import { RiDeleteBin5Line } from 'react-icons/ri'
import MultiSelectInput from 'src/Common/ui/MultiSelect'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router'
import * as Endpoints from '../../Entities/EndPoints'
import { RxCross2 } from 'react-icons/rx'
import { LiaSaveSolid } from 'react-icons/lia'
import { STATUS_ENUMS } from 'src/Entities/StatusEnums'
import MultiSelectInputDisable from 'src/Common/ui/MultiSelectDisable'
import { INITIATE } from 'src/Entities/CommonEntities'
import { useSettingsStore } from 'src/Containers/SettingsContainer/Store/Store'
import Axios from 'src/Axios'

const AddRisk = ({ isEditTrue, riskInfoData, handleApprove, ref, statusEnum, handleReject, editFormData, setIsEditTrue, riskInfo }) => {
    const getDepartmentId = JSON.parse(localStorage.getItem('departmentId'))
    const instance = Axios.getInstance()
    const { register, handleSubmit, formState: { errors, isSubmitting, isLoading }, setValue, clearErrors, setError, control, trigger } = useForm({
        mode: 'onChange',
        shouldUnregister: false, // Prevent fields from being unregistered
        defaultValues: {
            title: editFormData?.Title || '',
            description: editFormData?.Description || '',
            identifiedOn: editFormData?.IdentifiedOn || '',
            type: editFormData?.Type || '',
            category: editFormData?.Category || '',
            riskOwner: editFormData?.RiskOwner || '',
            impactedDepartnments: editFormData?.ImpactedDepartnments || [getDepartmentId],
            impactOfRisk: editFormData?.ImpactOfRisk || '',
            riskScore: editFormData?.riskScore || [],
            mitigationTasks: editFormData?.mitigationTasks || [{ id: 0, task: '', startDate: '', endDate: '', status: 5 }]
        }
    })
    const [ isSubmitted, setIsSubmitted ] = useState(false)
    const { t } = useTranslation()
    const [ internalExternal, setInternalExternal ] = useState('Internal')
    const [ selectedBox, setSelectedBox ] = useState(null)
    const [ formData, setformData ] = useState({})
    const [ heatMapSelection, setheatMapSelection ] = useState(true)
    const [ riskScore, setRiskScore ] = useState([])
    const [ initialRiskScore, setinitialRiskScore ] = useState({ impact: null, Probability: null, RiskScore: null })
    const [ open, setOpen ] = React.useState(false)
    const { CreateRisk } = useRiskStore()
    const createRiskDataLoading = useRiskStore((state) => state.createRiskDataLoading)
    const customNavigate = useCustomNavigate()
    const navigate = useNavigate()
    const [ riskTypes, setRiskTypes ] = useState([])
    const [ allCategories, setAllCategories ] = useState([])
    const [ impactedDepartments, setImpactedDepartments ] = useState([])
    const [ openWithdrawnPopup, setOpenWithdrawnPopup ] = useState(false)
    const [ scoringLevel, setScoringLevel ] = useState(RiskTypes.KISS_METHOD_ID)
    const [ mitigationTasks, setMitiationTasks ] = useState([
        { id: 0, task: '', startDate: '', endDate: '', status: 5 }
    ])
    const [ isRiskType, setIsRiskType ] = useState(true)
    const [ isMitigationTasks, setMitigationTasks ] = useState(true)
    const orgId = localStorage.getItem('orgId')
    const loginId = localStorage.getItem('userId')
    const userName = localStorage.getItem('userName')
    const headerArray = [ 'S.No', 'Task', 'Start Date', 'End Date', 'Action' ]
    const handleCheckRadioBox = (e) => {
        setInternalExternal(e)
    }
    const handleClose = () => {
        setOpen(false)
        setinitialRiskScore({ impact: null, Probability: null, RiskScore: null })
    }

    const { configurationData, getConfigurationBasedOrganization } = useSettingsStore()
    useEffect(() => {
        getConfigurationBasedOrganization(orgId)
    }, [])
    useEffect(() => {
        if (configurationData.length > 0) {
            const data = configurationData?.filter(element => element.kindId === 5)
            const heatmap = data?.find(element => element.values === 1)?.subtitleName
            setheatMapSelection(heatmap === '5x5 Heat Map')
        }
    }, [configurationData])
    useEffect(() => {
        if (location.pathname.includes('add-risk')) {
            setformData({
                ImpactedDepartnments: [getDepartmentId]
            })
            setValue('ImpactedDepartnments', getDepartmentId)
        }
    }, [location.pathname])
    useEffect(() => {
        if (isEditTrue) {
            setformData(editFormData)
            setMitiationTasks(editFormData?.mitigationTasks?.map((mapData, mapIdx) => {
                if (!mapData?.actions || mapData?.actions === null) {
                    return { ...mapData, newUpdate: true }
                } else {
                    return mapData
                }
            }))
            setRiskScore(editFormData?.riskScore)
            setInternalExternal(editFormData?.internalExternal)

            setValue('Title', editFormData?.Title || '')
            setValue('Description', editFormData?.Description || '')
            setValue('IdentifiedOn', editFormData?.IdentifiedOn || '')
            setValue('Type', editFormData?.Type || '')
            setValue('Category', editFormData?.Category || '')
            setValue('RiskOwner', editFormData?.RiskOwner || '')
            setValue('ImpactedDepartnments', editFormData?.ImpactedDepartnments || [getDepartmentId])
            setValue('ImpactOfRisk', editFormData?.ImpactOfRisk || '')
            setValue('riskScore', editFormData?.ImpactOfRisk || '')
            setValue('mitigation', editFormData?.ImpactOfRisk || '')
        }
    }, [ isEditTrue, editFormData, setValue ])

    const onValueChange = (value, name) => {
        if (name === MeetingTypes.RISK_OWNER || name === MeetingTypes.IMPACTED_DEPARTMENTS || name === MeetingTypes.CATEGORY || name === MeetingTypes.TYPE || name === MeetingTypes.SUGGESTED_MITIGATION) {
            setformData({ ...formData, [name]: value })
        } else if (name === MeetingTypes.IDENTIFIED_ON) {
            setformData({ ...formData, [name]: value?.toISOString() })
        } else {
            setformData({ ...formData, [name]: typeof value === 'string' ? value : value?.target?.value || '' })
        }
    }
    const handleRowClickOpenModal = (scoreData) => {
        setinitialRiskScore({
            impact: scoreData?.impact || null,
            Probability: scoreData?.Probability || null,
            RiskScore: scoreData?.RiskScore || null
        })
        setOpen(true)
    }

    const onValueChangeImpactOfRisk = (e, name, ind) => {
        if (name === MeetingTypes.IMPACTED_OF_RISK) {
            setRiskScore(riskScore?.map((mapData, mapIdx) => {
                if (mapIdx === ind) {
                    return { ...mapData, [name]: e }
                } else {
                    return mapData
                }
            }))
        }
    }

    const handleRemoveScore = (ind) => {
        setRiskScore(riskScore?.filter((_, filterIdx) => filterIdx !== ind))
    }

    const handleImageChange = (value, name) => {
        if (name === MeetingTypes.SUPPORTING_DOCUMENTS) {
            const newFiles = []

            value?.forEach((file) => {
                if (file) {
                    const reader = new FileReader()
                    reader.onloadend = () => {
                        const fileObject = {
                            file: reader.result.split(',')[1],
                            contentType: file.type,
                            fileName: file.name
                        }

                        newFiles.push(fileObject)

                        if (newFiles.length === value.length) {
                            setformData((prevData) => ({
                                ...prevData,
                                SupportingDocuments: [...newFiles]
                            }))
                        }
                    }
                    reader.readAsDataURL(file)
                }
            })
        }
    }

    const handleBoxClick = (x, y) => {
        const RiskScore = RiskTypes.RISK_SCROING_DATA[y][x]?.value
        const impact = x > 0 ? RiskTypes.RISK_SCROING_DATA[y][0]?.value : RiskScore
        const Probability = y < RiskTypes.RISK_SCROING_DATA.length - 1 ? RiskTypes.RISK_SCROING_DATA[RiskTypes.RISK_SCROING_DATA.length - 1][x]?.value : RiskScore

        setinitialRiskScore({
            impact: `${RiskTypes.yLabels[RiskTypes.IMPACT_VALUE.indexOf(impact)]}`,
            Probability: `${RiskTypes.xLabels[RiskTypes.PROBABILITY_VALUE.indexOf(Probability)]}`,
            RiskScore: `${(RiskScore === RiskTypes.RISK_SCORE_ONE || RiskScore === RiskTypes.RISK_SCORE_TWO) ? RiskTypes.RISK_LEVEL_CONTROLLED : (RiskScore === RiskTypes.RISK_SCORE_THREE || RiskScore === RiskTypes.RISK_SCORE_FOUR || RiskScore === RiskTypes.RISK_SCORE_FIVE || RiskScore === RiskTypes.RISK_SCORE_SIX) ? RiskTypes.RISK_LEVEL_LOW : (RiskScore === RiskTypes.RISK_SCORE_EIGHT || RiskScore === RiskTypes.RISK_SCORE_NINE) ? RiskTypes.RISK_LEVEL_MEDIUM : (RiskScore === RiskTypes.RISK_SCORE_TEN || RiskScore === RiskTypes.RISK_SCORE_TWELVE || RiskScore === RiskTypes.RISK_SCORE_FIFTEEN || RiskScore === RiskTypes.RISK_SCORE_SIXTEEN) ? RiskTypes.RISK_LEVEL_HIGH : (RiskScore === RiskTypes.RISK_SCORE_TWENTY || RiskScore === RiskTypes.RISK_SCORE_TWENTY_FIVE) && RiskTypes.RISK_LEVEL_EXTREME}`
        })
    }

    const handleThreeCrossBoxClick = (x, y) => {
        const RiskScore = RiskTypes.RISK_SCROING_DATA_THREE_CROSS[y][x]?.value
        const impact = x > 0 ? RiskTypes.RISK_SCROING_DATA_THREE_CROSS[y][0]?.value : RiskScore
        const Probability = y < RiskTypes.RISK_SCROING_DATA_THREE_CROSS.length - 1 ? RiskTypes.RISK_SCROING_DATA_THREE_CROSS[RiskTypes.RISK_SCROING_DATA_THREE_CROSS.length - 1][x]?.value : RiskScore

        setinitialRiskScore({
            impact: `${RiskTypes.Y_LABLES_THREE_CROSS[RiskTypes.IMPACT_VALUE_THREE_CROSS.indexOf(impact)]}`,
            Probability: `${RiskTypes.X_LABLES_THREE_CROSS[RiskTypes.PROBABILITY_VALUE_THREE_CROSS.indexOf(Probability)]}`,
            RiskScore: `${(RiskScore === RiskTypes.RISK_SCORE_ONE || RiskScore === RiskTypes.RISK_SCORE_TWO) ? RiskTypes.RISK_LEVEL_LOW : (RiskScore === RiskTypes.RISK_SCORE_THREE || RiskScore === RiskTypes.RISK_SCORE_FOUR) ? RiskTypes.RISK_LEVEL_MEDIUM : (RiskScore === RiskTypes.RISK_SCORE_SIX || RiskScore === RiskTypes.RISK_SCORE_NINE) && RiskTypes.RISK_LEVEL_EXTREME}`
        })
    }

    const handleCancel = () => {
        if (isEditTrue) {
            setIsEditTrue(false)
        } else {
            customNavigate(RoutePath.MAIN_CONTAINER.MAIN + RoutePath.RISK.URI + '/' + INITIATE)
        }
    }

    const handleSave = () => {
        // Create a new risk entry with updated values
        const newRiskValue = {
            id: 0,
            riskId: editFormData?.id,
            user: userName,
            status: riskScore?.length || 0,
            impact: initialRiskScore?.impact,
            Probability: initialRiskScore?.Probability,
            RiskScore: initialRiskScore?.RiskScore,
            impactOfRisk: ''
        }

        const existingIndex = riskScore.findIndex(
            (risk) => risk.riskId === editFormData?.id && risk.id === 0
        )

        let updatedRiskScore

        if (existingIndex !== -1) {
            updatedRiskScore = [
                ...riskScore.slice(0, existingIndex),
                newRiskValue,
                ...riskScore.slice(existingIndex + 1)
            ]
        } else {
            updatedRiskScore = [ ...riskScore, newRiskValue ]
        }

        setRiskScore(updatedRiskScore)
        setOpen(false)
    }

    // useEffect(() => {
    //     if (!riskScore.length) {
    //         setError('riskScore', { type: 'manual', message: 'Risk Score is required' })
    //     } else {
    //         clearErrors('riskScore')
    //     }

    //     if (!mitigationTasks[0]?.task?.trim().length) {
    //         setError('mitigationTasks', { type: 'manual', message: 'Mitigation Tasks is required' })
    //     } else {
    //         clearErrors('mitigationTasks')
    //     }
    // }, [ riskScore, mitigationTasks ]) // Watch dependencies

    // Add validation functions
    const validateRiskScore = () => {
        if (!riskScore || riskScore.length === 0) {
            setError('riskScore', { type: 'manual', message: 'Risk score selection is required' })
            return false
        }

        clearErrors('riskScore') // ✅ Clear error if everything is valid
        return true
    }

    const validateMitigationTasks = () => {
        if (!mitigationTasks || mitigationTasks.length === 0 || mitigationTasks[0].task.length === 0) {
            setError('mitigationTasks', { type: 'manual', message: 'Add at least one task' })
            return false
        }

        clearErrors('mitigationTasks') // ✅ Clear error if valid
        return true
    }

    useEffect(() => {
        if (riskScore.length > 0) {
            clearErrors('riskScore') // ✅ Clear errors when riskScore is updated
        }
        if (mitigationTasks.some(task => task.task.trim().length > 0)) {
            clearErrors('mitigationTasks') // ✅ Clear errors when mitigationTasks are valid
        }
    }, [ riskScore, mitigationTasks ])

    const handleAddRisk = async (value) => {
        // Validate all fields including our custom ones
        const isValid = await trigger()
        const isRiskScoreValid = validateRiskScore()
        const isMitigationValid = validateMitigationTasks()

        if (!isValid || !isRiskScoreValid || !isMitigationValid) {
            return
        }

        if (!riskScore.length || !mitigationTasks[0]?.task?.trim().length) {
            return
        }

        try {
            const selectedFiles = formData?.SupportingDocuments || []
            const addRiskFormate = {
                RiskId: isEditTrue ? editFormData?.id : 0,
                ContextId: isEditTrue ? editFormData?.ContextId : 0,
                // Title: formData?.Title,
                // Description: formData?.Description,
                Title: formData?.Title === undefined || formData?.Title === '' ? '' : formData?.Title,
                Description: formData?.Description === undefined || formData?.Description === '' ? '' : formData?.Description,
                IdentifiedOn: formData?.IdentifiedOn,
                SourceRiskId: internalExternal === 'Internal' ? 1 : 2,
                Type: formData?.Type,
                Category: formData?.Category,
                ImpactedDepartmentIds: formData?.ImpactedDepartnments,
                OwnerDepartmentId: formData?.RiskOwner,
                IssueConverted: false,
                Scores: riskScore?.map((mapData, mapIndex) => {
                    return {
                        id: mapData?.id ? mapData?.id : 0,
                        riskId: isEditTrue ? editFormData?.id : 0,
                        levelId: 1,
                        userId: mapData?.userId || loginId,
                        user: mapData?.user || userName,
                        impact: mapData?.impact,
                        probability: mapData?.Probability,
                        riskScore: mapData?.RiskScore,
                        impactOfRisk: mapData?.ImpactOfRisk,
                        probabilityJustification: '',
                        createdBy: loginId,
                        createdAt: new Date()?.toISOString(),
                        modifiedBy: loginId,
                        modifiedAt: new Date()?.toISOString(),
                        status: 1
                    }
                }),
                SuggestedMitigation: mitigationTasks?.map(mapDt => {
                    return {
                        id: mapDt.id ? mapDt.id : 0,
                        riskId: mapDt.riskId ? mapDt.riskId : 0,
                        name: mapDt?.task,
                        startDate: typeof mapDt?.startDate === 'object' ? mapDt?.startDate?.toISOString() : mapDt?.startDate,
                        endDate: typeof mapDt?.endDate === 'object' ? mapDt?.endDate?.toISOString() : mapDt?.endDate,
                        departmentId: '',
                        actions: mapDt.actions || '',
                        responsible: '',
                        createdBy: mapDt?.createdBy || loginId,
                        createdAt: new Date().toISOString(),
                        modifiedBy: mapDt?.modifiedBy || loginId,
                        modifiedAt: new Date().toISOString(),
                        status: mapDt.status
                    }
                }),
                Level1: riskInfoData?.level1 ? riskInfoData?.level1 : 8,
                Level2: riskInfoData?.level2 ? riskInfoData?.level2 : 8,
                CreatedBy: isEditTrue ? editFormData?.CreatedBy : loginId,
                CreatedAt: isEditTrue ? editFormData?.CreatedDate : new Date().toISOString(),
                ModifiedBy: loginId,
                ModifiedAt: new Date().toISOString(),
                Status: location.pathname.includes('rejected-risk') ? STATUS_ENUMS.Resubmit : riskInfoData?.status ? riskInfoData?.status : STATUS_ENUMS.Draft
            }

            const formValue = new FormData()

            Object.entries(addRiskFormate).forEach(([ key, value ]) => {
                if (Array.isArray(value)) {
                    if (key === 'Scores') {
                        value?.forEach((score, index) => {
                            Object?.entries(score)?.forEach(([ scoreKey, scoreValue ]) => {
                                formValue?.append(`Scores[${index}].${scoreKey}`, scoreValue)
                            })
                        })
                    } else if (key === 'ImpactedDepartmentIds') {
                        addRiskFormate?.ImpactedDepartmentIds?.forEach((deptId, index) => {
                            formValue?.append(`ImpactedDepartmentIds[${index}]`, deptId)
                        })
                    } else if (key === 'SuggestedMitigation') {
                        addRiskFormate?.SuggestedMitigation?.forEach((task, index) => {
                            Object?.entries(task)?.forEach(([ taskKey, taskValue ]) => {
                                formValue?.append(`SuggestedMitigation[${index}].${taskKey}`, taskValue)
                            })
                        })
                    } else {
                        value?.forEach(item => formValue.append(key, item))
                    }
                } else {
                    formValue?.append(key, value)
                }
            })

            selectedFiles?.forEach((task, index) => {
                Object.entries(task).forEach(([ taskKey, taskValue ]) => {
                    formValue.append(`SupportingDocuments[${index}].${taskKey}`, taskValue)
                })
            })

            await CreateRisk(loginId, formValue)
                .then((res) => {
                    if (res.data === 'Failed to add risk: Risk Withdrawn') {
                        setOpenWithdrawnPopup(true)
                    } else if (res?.data) {
                        toast.success(<p className='w-[100%] flex flex-row justify-evenly items-center' ><p>{value.replace('[ID]', res?.data)}</p></p>, {
                            position: 'top-right', theme: 'light'
                        })
                        const reqBody = [
                            {
                                recipientUserId: loginId,
                                message: `Risk ${res?.data} has been accepted by the department head.`,
                                kind: 3
                            },
                            {
                                recipientUserId: formData?.RiskOwner,
                                message: `Risk ${res?.data} has been accepted by the department head. Awaiting your approval.`,
                                kind: 3
                            }
                        ]
                        reqBody?.map((mapDt, _) => instance.post(Endpoints.BASE_ENDPOINT + '/api/v1/core/Notification/send', mapDt))
                        if (isEditTrue) {
                            instance.post(Endpoints.API_ENDPOINT + `/risk/RiskHistoryUpdateEntry?riskId=${editFormData?.id || 0}&loginId=${loginId}&type=${editFormData?.id ? 1 : 2}&referenceId=${editFormData?.id ? null : res?.data}`)
                                .then((tmlnRes) => tmlnRes)
                                .catch((err) => err)
                        }
                        if (!location.pathname.includes('rejected-risk') && isEditTrue) {
                            setIsEditTrue(false)
                            navigate(`/GRC${RoutePath.RISK.URI}/${res?.data}`, { state: { riskDetails: { riskId: editFormData?.id } } })
                        } else if (!location.pathname.includes('rejected-risk')) {
                            customNavigate(RoutePath.MAIN_CONTAINER.MAIN + RoutePath.RISK.URI + '/' + INITIATE)
                        } else {
                            setIsEditTrue(false)
                        }
                    } else {
                        const warningMessage = res?.err?.response?.data?.errors
                        if (warningMessage.length > 0) {
                            warningMessage.forEach((message) => {
                                toast.warning(<p>{message}</p>, { position: 'top-right', theme: 'light' })
                            })
                        } else {
                            toast.warning(<p>{warningMessage}</p>, { position: 'top-right', theme: 'light' })
                        }
                    }
                })
                .catch((err) => {
                    const warningMessage = err?.response?.data?.errors
                    if (Array.isArray(warningMessage) && warningMessage.length > 0) {
                        warningMessage.forEach((message) => {
                            toast.warning(<p>{message}</p>, { position: 'top-right', theme: 'light' })
                        })
                    } else {
                        toast.warning(<p>{warningMessage}</p>, { position: 'top-right', theme: 'light' })
                    }
                    console.warn(err)
                })
        } catch (error) {
            console.warn('Error adding risk:', error)
        }
    }

    const getAllRiskTypes = async () => {
        try {
            const response = await instance.get(Endpoints.API_ENDPOINT + '/masterController/GetAllRiskTypes')
            return response.data
        } catch (error) {
            console.error('Error fetching risk types:', error)
            throw error
        }
    }
    const getAllCategories = async () => {
        try {
            const response = await instance.get(Endpoints.API_ENDPOINT + '/masterController/GetAllCategories')
            return response.data
        } catch (error) {
            console.error('Error fetching risk types:', error)
            throw error
        }
    }
    const getAllDepartments = async () => {
        try {
            const response = await instance.get(Endpoints.API_ENDPOINT + `/user/GetDepatmentsByOrganization?organizationId=${orgId}`)
            return response.data
        } catch (error) {
            console.error('Error fetching risk types:', error)
            throw error
        }
    }

    const chipColorStyle = riskScoreValue => {
        let textColor = 'hsl(var(--foreground))'
        if (riskScoreValue === RiskTypes.CHIP_CONTROLLED) {
            textColor = 'hsl(var(--Controlled))'
        } else if (riskScoreValue === RiskTypes.CHIP_LOW) {
            textColor = 'hsl(var(--Low))'
        } else if (riskScoreValue === RiskTypes.CHIP_MEDIUM) {
            textColor = 'hsl(var(--Medium))'
        } else if (riskScoreValue === RiskTypes.CHIP_HIGH) {
            textColor = 'hsl(var(--High))'
        } else if (riskScoreValue === RiskTypes.CHIP_EXTREME) {
            textColor = 'hsl(var(--Extreme))'
        }
        return textColor
    }

    const handleScoringLevel = (event) => {
        setScoringLevel(event)
    }

    useEffect(() => {
        const fetchRiskTypes = async () => {
            try {
                const types = await getAllRiskTypes()
                setRiskTypes(types)
            } catch (error) {
                console.error('Error fetching risk types:', error)
            }
            try {
                const types = await getAllCategories()
                setAllCategories(types)
            } catch (error) {
                console.error('Error fetching all categories:', error)
            }
            try {
                const types = await getAllDepartments()
                setImpactedDepartments(types)
            } catch (error) {
                console.error('Error fetching imp dept:', error)
            }
        }

        fetchRiskTypes()
    }, [])
    const userDepartment = localStorage.getItem('department')
    const userRoles = JSON.parse(localStorage.getItem('userRoles'))
    return (
        <div className={isEditTrue ? 'w-full h-[100%] flex flex-col bg-background overflow-auto' : 'add-risk-container overflow-auto'}>
            <Loading isLoading={createRiskDataLoading} />
            <div className='add-risk-content flex flex-col'>
                <Card className='border-[0px] h-full risk-card'>
                    <CardContent className='p-3 h-full'>
                        <Box sx={{ p: 4, display: 'flex', alignItems: 'center' }}>
                            <p className='risk-content-title' style={{ margin: 0 }}>Risk Summary</p>
                            <div style={{ margin: '0px 20px 0px 20px', flex: 1, borderBottom: '3px solid hsl(var(--primary-foreground))' }}></div>
                        </Box>
                        <Box display="grid" sx={{ p: 4 }} gridTemplateColumns="repeat(12, 1fr)" gap={4}>
                            <Box gridColumn="span 3">
                                <div style={{ marginBottom: '2%' }}>
                                    <Input
                                        label="Risk Title"
                                        register={register}
                                        value={formData?.Title}
                                        type="text"
                                        placeholder="Enter Risk Title"
                                        onValueChange={onValueChange}
                                        name="Title"
                                        errors={errors}
                                        control={control}
                                        required
                                        rules={{
                                            required: 'This field is Required',
                                            validate: (value) => {
                                                const regex = /^\S+(?: \S+)*$/
                                                if (!regex.test(value)) {
                                                    return 'Remove unwanted spaces'
                                                }
                                            }
                                        }

                                        }
                                    />
                                </div>
                            </Box>
                            <Box gridColumn="span 6">
                                <div style={{ marginBottom: '2%' }}>
                                    <Textarea label="Description" className={cn('ml-[0px] border-2 border-grey-200')} register={register} value={formData?.Description} type="text" placeholder="Enter Description" onValueChange={onValueChange} name="Description" errors={errors} control={control}
                                        required
                                        rules={{
                                            required: 'This field is Required'
                                            // validate: (value) => {
                                            //     const regex = /^\S+(?: \S+)*$/
                                            //     if (!regex.test(value)) {
                                            //         return 'Remove unwanted spaces'
                                            //     }
                                            // }
                                        }} />
                                </div>
                            </Box>
                            <Box gridColumn="span 3">
                                <div style={{ marginBottom: '2%' }}>
                                    {/* <DateInput value={formData?.IdentifiedOn} name='IdentifiedOn' register={register} onValueChange={onValueChange} label={t('Identified On')} required /> */}
                                    <DatePickerInput
                                        errors={errors}
                                        control={control}
                                        required
                                        rules={{ required: t('IdentifiedOn date is required') }}
                                        name='IdentifiedOn'
                                        maxDate={new Date()}
                                        label={t('Identified On')}
                                        register={register}
                                        type="text"
                                        value={formData?.IdentifiedOn || ''}
                                        onValueChange={onValueChange}
                                    />
                                </div>
                            </Box>
                            <Box gridColumn="span 3">
                                <div className='mt-1'>
                                    <label className={cn('grc-label block mb-1')}>Source of Risk<span className='text-danger'>*</span></label>
                                    <RadioGroup onValueChange={handleCheckRadioBox} value={internalExternal} className='flex mt-3' >
                                        <div className='flex items-center space-x-2'>
                                            <RadioGroupItem value="Internal" />
                                            <label className='text-subMenu'>Internal</label>
                                        </div>
                                        <div className='flex items-center space-x-2'>
                                            <RadioGroupItem value="External" />
                                            <label className='text-subMenu'>External</label>
                                        </div>
                                    </RadioGroup>
                                </div>
                            </Box>
                            <Box gridColumn="span 3">
                                <div style={{ marginBottom: '2%' }}>
                                    <SelectInput label="Risk Nature" required rules={{ required: 'This field is Required' }} control={control} errors={errors} name="Type" placeholder="Select Risk Nature" onValueChange={onValueChange} value={formData?.Type} options={riskTypes.map(type => ({ value: type.id, label: type.name }))} />
                                </div>
                            </Box>
                            <Box gridColumn="span 3">
                                <div style={{ marginBottom: '2%' }}>
                                    <SelectInput label="Category" required rules={{ required: 'This field is Required' }} control={control} errors={errors} name="Category" placeholder="Select Category" onValueChange={onValueChange} value={formData?.Category} options={allCategories.map(type => ({ value: type.id, label: type.name }))} />
                                </div>
                            </Box>
                            <Box gridColumn="span 3">
                                <div style={{ marginBottom: '2%' }}>
                                    <MultiSelectInputDisable required rules={{
                                        validate: value => {
                                            if (value.length > 0 || value !== null) {
                                                return true
                                            }
                                            return 'Impacted Department is required'
                                        }
                                    }} label={t('Impacted Department')} control={control} errors={errors} name="ImpactedDepartnments" placeholder={t('Select Impacted Department')} defaultValue={formData?.ImpactedDepartnments} value={formData?.ImpactedDepartnments} options={impactedDepartments?.map((data) => ({ id: data?.id, value: data?.id, label: data?.name, status: data?.status, disable: data?.id === getDepartmentId }))}
                                    onValueChange={(value) => {
                                        onValueChange(value, 'ImpactedDepartnments')
                                        setValue('ImpactedDepartnments', value, { shouldValidate: true })
                                    }} />
                                </div>
                            </Box>
                            <Box gridColumn="span 3">
                                <div style={{ marginBottom: '2%' }}>
                                    <SelectInput label="Risk Owner" required rules={{ required: 'This field is Required' }} control={control} errors={errors} name="RiskOwner" placeholder="Risk Owner" onValueChange={onValueChange} value={formData?.RiskOwner} options={impactedDepartments.map(type => ({ value: type.id, label: type.name }))} />
                                </div>
                            </Box>
                            <Box gridColumn="span 9">
                                <MultiFileSelect
                                    name="SupportingDocuments"
                                    label="Supporting Documents"
                                    register={register}
                                    errors={errors}
                                    required={false}
                                    className='!w-[92%]'
                                    onValueChange={handleImageChange}
                                    defaultValue={formData?.SupportingDocuments}
                                />
                            </Box>
                        </Box>
                        <Box sx={{ p: 4, display: 'flex', alignItems: 'center' }}>
                            <p className='risk-content-title' style={{ margin: 0 }}>Risk Scoring</p>
                            <span className='text-danger text-[25px]'>*</span>
                            <div style={{ margin: '0px 20px 0px 20px', flex: 1, borderBottom: '3px solid hsl(var(--primary-foreground))' }}></div>
                        </Box>
                        <Box display="grid" sx={{ px: 4 }} gridTemplateColumns="repeat(12, 1fr)" gap={2}>
                            <Box gridColumn="span 7">
                                <div className='flex flex-row justify-end'>
                                    <Button
                                        variant='outlined'
                                        component='label'
                                        size='small'
                                        // disabled={(!Object.values(userRoles).some(value => value === 'Risk Manager')) || ((riskInfoData?.level1 === 8 && riskInfoData?.level2 === 8) ? riskScore?.length === 2 : (riskInfoData?.level1 === 3 && riskInfoData?.level2 === 8) ? riskScore?.length === 3 : false)}
                                        disabled={(riskInfoData?.level1 === RiskTypes.RISK_INFORMATION_STATUS_ID && riskInfoData?.level2 === RiskTypes.RISK_INFORMATION_STATUS_ID) ? (riskScore?.length === 2 || !Object.values(userRoles).some(value => value === 'Risk Manager')) : (riskInfoData?.level1 === RiskTypes.ANALYZE_STATUS_ID && riskInfoData?.level2 === RiskTypes.RISK_INFORMATION_STATUS_ID) ? (riskScore?.length === 3 || !Object.values(userRoles).some(value => value === 'Risk Manager')) : false}
                                        style={{ marginTop: '2rem', marginBottom: '20px', height: '40px', fontWeight: 'bold', fontSize: '12px', color: 'hsl(var(--primary))', padding: '12px', border: '2px solid hsl(var(--primary))' }}
                                        onClick={() => { setOpen(true); setinitialRiskScore(riskScore) }}
                                    >
                                        <span className="flex items-center" style={{ fontWeight: 'bold' }}>
                                            <IoAdd className="mr-2" size={15} /> Add Score
                                        </span>
                                    </Button>
                                </div>
                                <div style={{ marginBottom: '2%' }}>
                                    <table className="risk-table">
                                        <thead>
                                            <tr>
                                                <th>Users</th>
                                                <th>Impact</th>
                                                <th>Probability</th>
                                                <th>Risk Level</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {riskScore?.map((mapData, mapIdx) => {
                                                return <tr key={mapIdx}>
                                                    <td className='flex flex-col justify-center'>
                                                        <span>{mapData?.user === userName ? 'You' : mapData?.user || '-'}</span>
                                                        <span className='text-destructive'>{mapData?.role || '-'}</span>
                                                    </td>
                                                    <td className={cn('underline underline-offset-2', mapData?.id === 0 ? 'cursor-pointer' : '')} onClick={() => mapData?.id === 0 && handleRowClickOpenModal(mapData) }>{mapData?.impact || '-'}</td>
                                                    <td className={cn('underline underline-offset-2', mapData?.id === 0 ? 'cursor-pointer' : '')} onClick={() => mapData?.id === 0 && handleRowClickOpenModal(mapData) }>{mapData?.Probability || '-'}</td>
                                                    <td>
                                                        {mapData?.RiskScore ? <span className={'risk-level'} style={{ backgroundColor: chipColorStyle(mapData?.RiskScore) }}>{mapData?.RiskScore || '-'}</span> : '-'}
                                                    </td>
                                                    <td >{mapData?.id === 0
                                                        ? (<Tooltip title="Delete Score" placement="right" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }} style={{ width: 'fit-content !important' }}>
                                                            <span><RiDeleteBin5Line onClick={() => { handleRemoveScore(mapIdx) }} size={24} className='cursor-pointer' color='hsl(var(--destructive))' /></span>
                                                        </Tooltip>
                                                        )
                                                        : ('-')}
                                                    </td>
                                                </tr>
                                            })}
                                        </tbody>
                                    </table>
                                    {errors.riskScore && (
                                        <p className="grc-error-msg text-danger">{errors.riskScore.message}</p>
                                    )}
                                </div>
                            </Box>
                        </Box>
                        <Box display="grid" sx={{ p: 4 }} gridTemplateColumns="repeat(12, 1fr)" gap={2}>
                            {riskScore?.map((mapData, mapIdx) => <Box key={mapIdx} gridColumn={`span ${riskScore?.length > 1 ? 12 / riskScore?.length : 7}`}>
                                <div className='relative' style={{ marginBottom: '2%' }}>
                                    <Textarea disabled={mapData?.id !== 0} className={cn('ml-[0px]')} label="Impact of Risk" rules={{
                                        validate: (value) => {
                                            if (!value) return t('This field is required')
                                            const regex = /^\S+(?: \S+)*$/
                                            if (!regex.test(value)) {
                                                return 'Remove unwanted spaces'
                                            }
                                            return true
                                        }
                                    }} register={register} value={mapData?.ImpactOfRisk} type="text" placeholder="Enter Impact of Risk" onValueChange={(e) => {
                                        const value = e.slice(0, 250)
                                        onValueChangeImpactOfRisk(value, 'ImpactOfRisk', mapIdx)
                                    }} name="ImpactOfRisk" errors={errors} control={control} required={mapIdx === 0} maxLength={250} />
                                    <div className={cn('absolute bottom-[6px] right-[10px] text-muted text-[10px]', mapData?.ImpactOfRisk?.length > 250 ? '!text-danger' : 'text-muted')}>{mapData?.ImpactOfRisk?.length || 0}/250</div>
                                </div>
                            </Box>)}
                        </Box>
                        <Box sx={{ p: 4, display: 'flex', alignItems: 'center' }}>
                            <p className='risk-content-title' style={{ margin: 0 }}>Suggest Mitigation</p>
                            <span className='text-danger text-[25px]'>*</span>
                            <div style={{ margin: '0px 20px 0px 20px', flex: 1, borderBottom: '3px solid hsl(var(--primary-foreground))' }}></div>
                        </Box>
                        <Box display="grid" sx={{ p: 3 }} gridTemplateColumns="repeat(12, 1fr)" gap={2}>
                            <Box gridColumn="span 10">
                                <AddOnTable
                                    header={headerArray}
                                    setTasks={setMitiationTasks}
                                    tasks={mitigationTasks}
                                    riskDeails={editFormData}
                                    control={control}
                                    errors={errors}
                                />
                            </Box>
                        </Box>
                        {errors && mitigationTasks && errors.mitigationTasks && <p className='grc-error-msg text-danger p-7'>{errors && errors.mitigationTasks?.message}</p>}
                    </CardContent>
                </Card>
                <Dialog
                    maxWidth
                    open={open}
                    onClose={handleClose}
                >
                    <Box sx={{ width: 1000 }} >
                        <DialogTitle sx={{ padding: '0px 10px 0px 10px', display: 'flex', alignItems: 'center', backgroundColor: 'hsl(var(--primary))', flexDirection: 'row', height: '40px', justifyContent: 'center' }}>
                            <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#fff' }}>Choose Risk Score</div>
                        </DialogTitle>
                        <DialogContent>
                            <div style={{ width: '100%', display: 'flex', flexDirection: 'row' }}>
                                <div style={{ width: '45%', padding: '30px' }}>
                                    <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                        <img src='/Assets/Impact.svg' style={{ height: '260px' }} alt="Impact" />
                                        <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                            {heatMapSelection
                                                    ? <Heatmap
                                                        xLabels={RiskTypes.xLabels?.map((dt, indedx) => <p key={indedx} style={{ fontSize: '10px' }} >{dt}</p>)}
                                                        yLabels={RiskTypes.yLabels.map((dt, indedx) => <p key={indedx} style={{ fontSize: '10px', marginLeft: '-50px' }} >{dt}</p>)}
                                                        xLabelsLocation={'bottom'}
                                                        xLabelWidth={50}
                                                        data={RiskTypes.RISK_SCROING_DATA}
                                                        squares
                                                        height={50}
                                                        onClick={(x, y) => {
                                                            handleBoxClick(x, y)
                                                            setSelectedBox({ x, y })
                                                        }}
                                                          title={(value) => value?.value ?? ""}
                                                        cellStyle={(background, value, min, max, data, x, y) => {
                                                            return {
                                                            fontSize: '12.5px',
                                                            backgroundColor: value?.color,
                                                            color: '#fff',
                                                            border: selectedBox && selectedBox.x === x && selectedBox.y === y ? '7px solid #ffffff6e' : 'none'
                                                        }}}
                                                    />
                                                : <Heatmap
                                                    xLabels={RiskTypes.X_LABLES_THREE_CROSS?.map((dt, indedx) => <p key={indedx} style={{ fontSize: '10px' }} >{dt}</p>)}
                                                    yLabels={RiskTypes.Y_LABLES_THREE_CROSS?.map((dt, indedx) => <p key={indedx} style={{ fontSize: '10px', marginLeft: '-50px' }} >{dt}</p>)}
                                                    xLabelsLocation={'bottom'}
                                                    xLabelWidth={50}
                                                    data={RiskTypes.RISK_SCROING_DATA_THREE_CROSS}
                                                    squares
                                                    height={50}
                                                    title={(value) => value?.value ?? ""}

                                                    onClick={(x, y) => {
                                                        handleThreeCrossBoxClick(x, y)
                                                        setSelectedBox({ x, y })
                                                    }}
                                                    cellStyle={(background, value, min, max, data, x, y) => ({
                                                        fontSize: '12.5px',
                                                        backgroundColor: value?.color,
                                                        color: '#fff',
                                                            title: value?.value ? String(value.value) : "",

                                                        border: selectedBox && selectedBox.x === x && selectedBox.y === y ? '7px solid #ffffff6e' : 'none'
                                                    })}
                                                />}
                                        </div>
                                    </div>
                                    <img src='/Assets/Probability.svg' style={{ paddingLeft: '60px', marginLeft: '21px', paddingTop: '20px', marginBottom: '-40px' }} alt="Impact" />
                                </div>
                                <span style={{
                                    display: 'inline-block',
                                    width: '2px',
                                    backgroundColor: 'hsl(var(--primary-foreground))',
                                    margin: ' 0 10px',
                                    height: ' 22em'
                                }} />
                                <div style={{ width: '55%', marginLeft: '1rem', display: 'flex', flexDirection: 'column' }}>
                                    <Box display="grid" className='w-[100%] h-full'>
                                        <div style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', fontSize: '13px' }}>
                                            <p style={{ fontWeight: 'bold', marginRight: '1rem', fontSize: '12px' }}>Risk Level</p>
                                            {heatMapSelection
                                                ? RiskTypes.RISK_RATINNG?.map((data, ind) => {
                                                    return (
                                                        <div style={{ width: 65, border: '0.5px solid black', color: '#fff', textAlign: 'center', backgroundColor: data?.color, fontSize: '12px' }} key={ind} >{data?.title}</div>
                                                    )
                                                })
                                                : RiskTypes.RISK_RATINNG_THREE_CROSS?.map((data, ind) => {
                                                    return (
                                                        <div style={{ width: 65, border: '0.5px solid black', color: '#fff', textAlign: 'center', backgroundColor: data?.color, fontSize: '12px' }} key={ind} >{data?.title}</div>
                                                    )
                                                })
                                            }
                                        </div>
                                        <Box gridColumn="span 12" className="max-w-30 font-medium">
                                            <h4 style={{ display: 'inline-block', marginRight: '0.2rem', fontWeight: 'bold', color: 'hsl(var(--primary))' }}>
                                                Impact :
                                            </h4>
                                            <span>
                                                {initialRiskScore?.impact || ''}
                                            </span>
                                        </Box>
                                        <Box gridColumn="span 12" className="max-w-30 font-medium">
                                            <h4 style={{ display: 'inline-block', fontWeight: 'bold', marginRight: '0.2rem', color: 'hsl(var(--primary))' }}>
                                            Probability :
                                            </h4>
                                            <span>
                                                {initialRiskScore?.Probability || ''}
                                            </span>
                                        </Box>
                                        <Box gridColumn="span 12" className=" max-w-30 font-medium">
                                            <h4 style={{ display: 'inline-block', fontWeight: 'bold', marginRight: '0.2rem', color: 'hsl(var(--primary))' }}>
                                            Risk Level :
                                            </h4>
                                            <span>
                                                <Chip
                                                    key={initialRiskScore?.RiskScore || ''}
                                                    label={initialRiskScore?.RiskScore || ''}
                                                    sx={{
                                                        width: '90px',
                                                        // height: '90%',
                                                        color: 'hsl(var(--foreground))',
                                                        backgroundColor: chipColorStyle(initialRiskScore?.RiskScore)
                                                    }}

                                                />
                                            </span>
                                        </Box>
                                    </Box>
                                </div>
                            </div>
                        </DialogContent>
                        <DialogActions style={{ width: '100%', display: 'flex', padding: '15px 30px 15px 30px', flexDirection: 'row', justifyContent: 'flex-end' }}>

                            <div className='d-flex content-end'>
                                <SaveCancelButton handleCancel={handleClose} handleSave={handleSave} readOnly={!initialRiskScore?.impact} />
                            </div>
                        </DialogActions>
                    </Box>
                </Dialog>
                <Dialog
                    maxWidth
                    open={openWithdrawnPopup}
                    onClose={handleClose}
                >
                    <Box sx={{ width: 400 }} >
                        <DialogTitle sx={{ padding: '0px 10px 0px 10px', display: 'flex', alignItems: 'center', backgroundColor: 'hsl(var(--destructive))', flexDirection: 'row', height: '40px', justifyContent: 'center' }}>
                            <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#fff' }}>Warning</div>
                        </DialogTitle>
                        <DialogContent sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'col', justifyContent: 'center', alignItems: 'center' }}>
                            <p className='text-muted pt-[24px] text-[14px]'>
                                {`This Risk has been already withdrawn. ${'You'} can't proceed further`}
                            </p>
                        </DialogContent>
                        <DialogActions style={{ borderTop: '2px solid hsl(var(--border))', width: '100%', display: 'flex', padding: '15px 30px 15px 30px', flexDirection: 'row', justifyContent: 'flex-end' }}>
                            <div className='d-flex content-end'>
                                <Button
                                    variant='outline'
                                    style={{ color: 'hsl(var(--destructive))', borderColor: 'hsl(var(--destructive))' }}
                                    onClick={() => {
                                        customNavigate(RoutePath.MAIN_CONTAINER.MAIN + RoutePath.RISK.URI + '/' + INITIATE)
                                    }}
                                >
                                    {t('Close')}
                                </Button>
                            </div>
                        </DialogActions>
                    </Box>
                </Dialog>
            </div>
            {(isEditTrue && ((riskInfo?.level1 === 8 && riskInfo?.department === userDepartment) || (riskInfo?.ownerDepartmentId === userDepartment && riskInfo.level2 === 8))) || (riskInfo?.department === userDepartment && riskInfo.status === 1 && ((riskInfo.level1 === STATUS_ENUMS.Rejected && riskInfo.level2 === STATUS_ENUMS.Pending) || (riskInfo.level1 === STATUS_ENUMS.Approved && riskInfo.level2 === STATUS_ENUMS.Rejected))) || location.pathname.includes('add-risk')
                ? <div style={{ borderTop: '2px solid hsl(var(--primary-foreground))' }} className='flex-shrink-0 h-[60px] relative flex-grow'>
                    <SaveCancelButton isEditTrue={isEditTrue} handleCancel={handleCancel} loading={isSubmitting || isLoading || createRiskDataLoading} handleSave={() => {
                        validateRiskScore()
                        validateMitigationTasks()
                        handleSubmit(() => {
                            handleAddRisk(isEditTrue ? 'Changes to Risk [ID] have been updated' : 'Risk [ID] has been successfully submitted as Draft')
                        })()
                    }} />
                </div>
                : null}
        </div>
    )
}

export default AddRisk
